import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { ProjectMasterMilestoneService } from '@zaoblako/web/core/services/project/project-master-milestone.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { StandardSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/standard-dropdown/standard-single-select/standard-single-select.component';
import type { MasterMilestoneFindInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find.dto';

/**
 * @deprecated Use `crm-standard-single-select` and `ProjectMasterMilestoneService.dropdownDescriptorUrl`.
 */
@Component({
  selector: 'crm-master-milestone-single-select',
  standalone: true,
  imports: [SingleSelectComponent, StandardSingleSelectComponent],
  templateUrl: './master-milestone-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MasterMilestoneSingleSelectComponent implements OnInit {
  @Input() public masterMilestones: MasterMilestoneFindInterface[] = [];
  @Input() public selectedMasterMilestone: MasterMilestoneFindInterface;
  @Output() public selectedMasterMilestoneChange = new EventEmitter<MasterMilestoneFindInterface>();
  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;
  @Input() public placeholder = '\u00A0';

  public loading = false;
  public useStandard = false;
  public readonly descriptorUrl: string;

  public constructor(
    masterMilestoneService: ProjectMasterMilestoneService,
    private readonly globalService: GlobalService
  ) {
    this.descriptorUrl = masterMilestoneService.dropdownDescriptorUrl;
  }

  public ngOnInit(): void {
    this.useStandard = !this.customRequest && !!this.globalService.globalInfo?.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled;
  }

  public onSelected = (masterMilestone: MasterMilestoneFindInterface): void => {
    this.selectedMasterMilestone = masterMilestone;
    this.selectedMasterMilestoneChange.emit(masterMilestone);
  };
}
